import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {apiCall} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
class TicketAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            ticketFormData : {
                title:'',
                description:'',
            }
        }
    }

    handleChance = (e) => {
        const {name,value} = e.target;
        this.setState(prevState => ({
            ticketFormData : {
                ...prevState.ticketFormData,
                [name] : value
            }
        }))
    }
    handleTicketSubmit = async (event) => {
        event.preventDefault();
        this.setState({loading:true});
        try {
            const response = await apiCall('business/tickets/add','post',{title: this.state.ticketFormData.title,description: this.state.ticketFormData.description})
            this.setState({loading:false})
            mainHelper.toastMessage(response.status,response.message);
        }catch (e) {
            this.setState({loading:false})
        }
    };
    render() {
        const {loading}=this.state;
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Yeni Destek Talebi"
                            Breadcrumb={[
                                { name: "Destek Talepleri", navigate: "tickets" },
                                { name: "Yeni Destek Talebi", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <form onSubmit={this.handleTicketSubmit}>
                                        <div className="body text-center">
                                            <h6>Destek Talebi Oluştur</h6>
                                            <div className="row clearfix justify-content-center">
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <input
                                                            name="title"
                                                            id="title"
                                                            className="form-control"
                                                            placeholder="Başlık"
                                                            type="text"
                                                            onChange={this.handleChance}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <textarea
                                                            name="description"
                                                            id="description"
                                                            className="form-control"
                                                            placeholder="Açıklama"
                                                            onChange={this.handleChance}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row clearfix justify-content-center">
                                                <div className="col-lg-6 col-md-12">
                                                    {loading ? (
                                                            <button className="btn btn-outline-primary btn-block"
                                                                    disabled={true}
                                                                    style={{textAlign: "-webkit-center"}}>
                                                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                                                height={'24px'}
                                                                                                color="#268bd2"></ReactLoading>
                                                            </button>
                                                        ) :
                                                        <button
                                                            className="btn btn-outline-primary btn-block"
                                                            type="submit">
                                                            Güncelle
                                                        </button>}

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ioTReducer}) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withRouter(connect(mapStateToProps, {})(TicketAdd));
